// English strings for the demoguard stream (PD-714 demo mode; PD-720 – PD-739). Arabic: ar-demoguard.ts.
export const enDemoguard = {
  // ------------------------------------------------------------ API (PD-725)
  'api.demoReadOnly': 'This is a demo: changes are not saved.',
  // ------------------------------------------------------------ banner and notices (PD-729, PD-730)
  'demo.banner': 'Demo — nothing you do is saved or sent',
  'demo.bannerRegion': 'Demo mode',
  'demo.notice.title': 'Not saved — this is a demo',
  'demo.notice.body': 'This is a demo: changes are not saved. What you entered is still here, so you can keep exploring.',
  'demo.notice.dismiss': 'Dismiss',
  // ------------------------------------------------------------ UAE PASS (PD-727)
  'ver.pass.demoUnavailable': 'UAE PASS sign-in is not available in the demo. At a real site you can also be verified at reception.',
  // ------------------------------------------------------------ console environment panel (PD-720)
  'set.env.demo': 'Demo mode (IS_DEMO)',
  'set.env.demoOn': 'On — read-only, nothing is sent',
  'set.env.demoOff': 'Off',
} as const;
